import { useAtomValue } from 'jotai';

import { ProviderDrawerState, drawerStateAtom, numWaitingVisitorsAtom } from '../state';
import { getIsClientListDrawerOpen } from '../utils';
import { ClientListDrawerControlMenuItem } from './ClientListDrawerControlMenuItem';
import { useToggleProviderDrawerStateCallback } from './useToggleProviderDrawerStateCallback';

export function ClientListDrawerControlMenuItemWrapper() {
  const isClientListDrawerOpen = getIsClientListDrawerOpen(useAtomValue(drawerStateAtom));
  const numberOfWaitingClients = useAtomValue(numWaitingVisitorsAtom);
  const toggleClientListDrawer = useToggleProviderDrawerStateCallback(ProviderDrawerState.CLIENTS);

  return (
    <ClientListDrawerControlMenuItem
      isClientListDrawerOpen={isClientListDrawerOpen}
      numberOfWaitingClients={numberOfWaitingClients}
      onClickClientsButton={toggleClientListDrawer}
    />
  );
}
